import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19.778 13.111v2.778a6.111 6.111 0 0 1-12.222 0V13.11m12.222 0a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444m-12.222 0c3.068 0 5.555-2.394 5.555-5.347v-2.43c0-.741-.555-2.223-2.778-2.223m-2.777 10C4.487 13.111 2 10.717 2 7.764v-2.43c0-.741.556-2.223 2.778-2.223M10.333 2v2.222M4.778 2v2.222"
    }, null, -1)
  ])))
}
export default { render: render }